import { cva } from 'class-variance-authority'

export { default as Badge } from './Badge.vue'

export const badgeVariants = cva(
    'inline-flex items-center rounded-full ring-1 ring-inset px-2.5 py-1 text-xs font-medium transition-colors focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2',
    {
        variants: {
            variant: {
                default: 'bg-blue-50 text-blue-700 ring-blue-600/20',
                secondary: 'bg-gray-50 text-gray-600 ring-gray-500/10',
                destructive: 'bg-red-50 text-red-700 ring-red-600/10',
                success: 'bg-green-50 text-green-700 ring-green-600/20',
                outline: 'ring-0 border text-foreground',
            },
        },
        defaultVariants: {
            variant: 'default',
        },
    }
)
